import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code", "resendButton", "resendLabel"]
  static values = { resendAvailableAt: String }

  connect() {
    this.submitting = false

    if (!this.hasResendAvailableAtValue || !this.hasResendButtonTarget) return

    this.updateResendCountdown()
    this.resendCountdown = setInterval(() => this.updateResendCountdown(), 1000)
  }

  disconnect() {
    clearInterval(this.resendCountdown)
  }

  submitWhenComplete() {
    const code = this.codeTarget.value.replace(/\D/g, "").slice(0, 6)
    this.codeTarget.value = code
    if (code.length === 6 && !this.submitting) this.element.requestSubmit()
  }

  preventDuplicateSubmit(event) {
    if (this.submitting) {
      event.preventDefault()
      return
    }

    this.submitting = true
  }

  updateResendCountdown() {
    const availableAt = Date.parse(this.resendAvailableAtValue)
    const remainingSeconds = Math.max(0, Math.ceil((availableAt - Date.now()) / 1000))

    if (!Number.isFinite(availableAt) || remainingSeconds === 0) {
      this.resendButtonTarget.disabled = false
      if (this.hasResendLabelTarget) this.resendLabelTarget.textContent = "Send a new code"
      clearInterval(this.resendCountdown)
      return
    }

    const minutes = Math.floor(remainingSeconds / 60)
    const seconds = String(remainingSeconds % 60).padStart(2, "0")
    this.resendButtonTarget.disabled = true
    if (this.hasResendLabelTarget) this.resendLabelTarget.textContent = `Send a new code in ${minutes}:${seconds}`
  }
}
